export default "__VITE_ASSET__KYw7Ukkp__"